export const SOCKET_EVENTS = {
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
  GAME_STATE: "GAME_STATE",
  WALLET_UPDATED: "WALLET_UPDATED",
  AVIATOR_ROUND_CREATED: "AVIATOR_ROUND_CREATED",
  AVIATOR_BETTING: "AVIATOR_BETTING",
  AVIATOR_FLIGHT_STARTED: "AVIATOR_FLIGHT_STARTED",
  AVIATOR_MULTIPLIER: "AVIATOR_MULTIPLIER",
  AVIATOR_CRASH: "AVIATOR_CRASH",
  AVIATOR_SETTLED: "AVIATOR_SETTLED",
  AVIATOR_BET_PLACED: "AVIATOR_BET_PLACED",
  AVIATOR_CASHOUT: "AVIATOR_CASHOUT",
  ERROR: "ERROR",
};
